import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { AlertOctagon, ShieldAlert, Ban } from "lucide-react";

export default function Safety() {
  const [rules, setRules] = useState([]);
  useEffect(() => { api.get("/content/safety").then((r) => setRules(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6" data-testid="safety-page">
      {/* STOP banner */}
      <div className="rounded-2xl border-2 border-red-500 bg-red-50 p-6 sm:p-8" data-testid="stop-banner">
        <div className="flex items-center gap-3 text-red-700">
          <AlertOctagon className="w-10 h-10 shrink-0" />
          <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">STOP TROUBLESHOOTING & ESCALATE</h1>
        </div>
        <p className="text-red-800 mt-3">
          Staff must stop customer troubleshooting immediately and escalate if there is any of the following:
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {rules.map((r) => (
          <Card key={r.id} className="p-5 border-2 border-red-200 bg-red-50/50" data-testid={`safety-rule-${r.id}`}>
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-lg bg-red-500 text-white flex items-center justify-center shrink-0">
                <ShieldAlert className="w-5 h-5" />
              </div>
              <div>
                <h3 className="font-heading font-bold text-red-800">{r.title}</h3>
                <p className="text-sm text-red-700 mt-0.5">{r.description}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>

      <Card className="p-6 border-2 border-red-400 bg-white" data-testid="powered-base-warning">
        <div className="flex items-center gap-3 text-red-700">
          <Ban className="w-7 h-7 shrink-0" />
          <div>
            <h3 className="font-heading font-bold text-lg">Never crawl under a powered adjustable base</h3>
            <p className="text-sm text-red-700 mt-1">
              Customers must never be advised to crawl underneath a powered adjustable base. Ensure the base is unplugged before any inspection near moving parts.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
